export default "__VITE_ASSET__DwRMu1A3__"